import { useParams, useSearchParams } from "react-router-dom";
import GreetingOccasionCategoryService from "../../../services/GreetingOccasionCategoryService";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import Breadcrumbs from "../../../components/breadcrumbs";
import GreetingOccasionCategoryEditForm from "./ui/greeting-occasion-category-edit-form";
import GreetingOccasionCategorySkeleton from "./skeleton/greeting-occasion-category-skeleton";
import GreetingOccasionSubcategoriesTable from "./ui/greeting-occasion-subcategories-table";
import { GreetingOccasionCategoryViewModel } from "../../../viewModels";

export default function GreetingOccasionCategoryEditPage(){
     const { id } = useParams();
     const [searchParams] = useSearchParams();
      const api = new GreetingOccasionCategoryService();
      const [greetingOccasionCategory, setGreetingOccasionCategory] = useState<GreetingOccasionCategoryViewModel>();
      const [loading, setLoading] = useState(true);
      useEffect(() => { 
        fetchGreetingOccasionCategory();
      }, [searchParams.get("reload")]);      
      const fetchGreetingOccasionCategory = async () => {
        if (id) {
          const data = await api.getGreetingOccasionCategoryById(parseInt(id));
          setGreetingOccasionCategory(data);
          setLoading(false);          
        }
      };

      if (!greetingOccasionCategory && !loading) return <NotFound message="Greeting Occasion Category not found." />;
    
      return (
        <main className="max-w-3xl ">
          <Breadcrumbs
            breadcrumbs={[
              { label: "Greeting Occasion Categories", href: "/admin/greeting-occasion-categories" },
              {
                label: "Edit",
                href: `/admin/greeting-occasion-categories/edit/${id}`,
                active: true,
              },
            ]}
          />
          {!loading && greetingOccasionCategory ? (<>
            <GreetingOccasionCategoryEditForm greetingOccasionCategory={greetingOccasionCategory} />
            <GreetingOccasionSubcategoriesTable category={greetingOccasionCategory} />
          
          </>
          ) : (
            <GreetingOccasionCategorySkeleton />
          )}
        </main>
      );
    }

